<!-- Main Container -->
<elder-basic-pane-layout class="full">
  <elder-pane>
    <elder-table class="flex" matSort [data]="data" (itemClick)="openDetail($event)">
      <!-- Search Component -->
      <elder-data-toolbar *elderTableToolbar [canAdd]="false" [canRemove]="false" [canMore]="false">
        <ng-template elderToolbarContent="center">
          <div class="flex-60 layout-col pt-xs">
            <elder-search-box
              dense
              [autoPanel]="true"
              [elderSearchContext]="data.filter"
              class="flex"
              queryKey="query"
            >
              <!-- Advanced search -->
              <elder-search-panel class="layout-col p-sm">
                <div class="layout-row place-start-center gap-sm">
                  <mat-form-field subscriptSizing="dynamic">
                    <input
                      elderSearchInput
                      matInput
                      name="idPart"
                      ngModel
                      placeholder="{{ 'materials.number' | translate }}"
                    />
                  </mat-form-field>

                  <mat-slide-toggle elderSearchInput name="archived" ngModel>
                    {{ 'context.archived' | translate }}
                  </mat-slide-toggle>
                </div>
              </elder-search-panel>
            </elder-search-box>
          </div>
        </ng-template>
      </elder-data-toolbar>

      <!-- archived Column -->
      <ng-container matColumnDef="archived">
        <th *matHeaderCellDef class="width-5p" mat-header-cell mat-sort-header></th>
        <td *matCellDef="let product" mat-cell>
          @if (product?.archived) {
            <mat-icon>archive</mat-icon>
          } @else {
            <mat-icon color="primary">layers</mat-icon>
          }
        </td>
      </ng-container>

      <!-- id Column -->
      <ng-container matColumnDef="id">
        <th *matHeaderCellDef class="width-10p" mat-header-cell mat-sort-header>
          {{ 'context.id' | translate }}
        </th>
        <td *matCellDef="let material" mat-cell>{{ material.id }}</td>
      </ng-container>

      <!-- description Column -->
      <ng-container matColumnDef="description">
        <th
          *matHeaderCellDef
          class="width-20p"
          mat-header-cell
          mat-sort-header="descriptionI18n.text"
        >
          {{ 'context.description' | translate }}
        </th>
        <td *matCellDef="let material" mat-cell>
          <div class="layout-col">
            <span>{{ material.description }}</span>
            @if (material.description2) {
              <span>{{ material.description2 }}</span>
            }
            @if (material.description3) {
              <span>{{ material.description3 }}</span>
            }
          </div>
        </td>
      </ng-container>

      <!-- typeId Column -->
      <ng-container matColumnDef="typeId">
        <th *matHeaderCellDef class="width-10p" mat-header-cell mat-sort-header>
          {{ 'context.type' | translate }}
        </th>
        <td *matCellDef="let material" mat-cell>{{ material.typeId }}</td>
      </ng-container>

      <!-- searchTerm Column -->
      <ng-container matColumnDef="searchTerm">
        <th *matHeaderCellDef class="width-10p" mat-header-cell mat-sort-header>
          {{ 'context.searchTerm' | translate }}
        </th>
        <td *matCellDef="let material" mat-cell>{{ material.searchTerm }}</td>
      </ng-container>

      <!-- groupId Column -->
      <ng-container matColumnDef="groupId">
        <th *matHeaderCellDef class="width-10p" mat-header-cell mat-sort-header>
          {{ 'context.group' | translate }}
        </th>
        <td *matCellDef="let material" mat-cell>{{ material.groupId }}</td>
      </ng-container>

      <!-- createdAt Column -->
      <ng-container matColumnDef="createdAt">
        <th *matHeaderCellDef class="width-10p" mat-header-cell mat-sort-header>
          {{ 'context.created' | translate }}
        </th>
        <td
          *matCellDef="let material"
          mat-cell
          matTooltip="{{ material.createdAt | date: 'short' }}"
        >
          <span class="mat-caption">{{ material.createdAt | date: 'dd.MM.yyyy' }}</span>
        </td>
      </ng-container>
    </elder-table>
  </elder-pane>
</elder-basic-pane-layout>
